import { FC, useEffect } from 'react'
import { useRouter } from 'next/router'

type Props = {
  slot: string
  format?: 'auto' | 'rectangle' | 'vertical' | 'horizontal'
  responsive?: boolean
  style?: React.CSSProperties
}

declare global {
  interface Window {
    adsbygoogle: any[]
  }
}

export const GoogleAdSense: FC<Props> = ({
  slot,
  format = 'auto',
  responsive = true,
  style = { display: 'block' },
}) => {
  const router = useRouter()
  const isEnglish = router.locale === 'en'
  const isDevelopment = process.env.NODE_ENV === 'development'

  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && isEnglish && slot) {
        ;(window.adsbygoogle = window.adsbygoogle || []).push({})
      }
    } catch (error) {
      console.error('AdSense error:', error)
    }
  }, [isEnglish, slot])

  // 英語版でない、またはslotが空の場合は非表示
  if (!isEnglish || !slot) {
    return null
  }

  return (
    <ins
      className='adsbygoogle'
      style={style}
      data-ad-client={`ca-pub-${process.env.NEXT_PUBLIC_ADSENSE_ID}`}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive}
      data-adtest={isDevelopment ? 'on' : undefined}
    />
  )
}
